import { combineReducers } from "redux";
import { createReducer } from "typesafe-actions";
import { getRolesActions } from "../actions/roles.actions";
import { RoleDto } from "../dtos/role.dtos";

const rolesReducer = combineReducers({
    roles: createReducer([] as RoleDto[])
      .handleAction([getRolesActions.success], (state, action) => action.payload),
  });
  
  export default rolesReducer;